import React from "react";
import SelectWithClear from "Components/UI/Form/SelectWithClear";

//MUI
import Grid from "@mui/material/Grid";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import PriceField from "Components/UI/Form/PriceField";

export default function InvoiceFormTerms({
  formData,
  FORM_MODE,
  services,
  boolOptions,
  handleInputChange,
}) {
  
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="Service"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              value={formData.Service}
              onChange={(e) => handleInputChange("Service", e.target.value)}
              label="Tjänst"
            >
              {services.map((option) => (
                <MenuItem key={option.Value} value={option.Value}>
                  {option.Name}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>Regress utförs</InputLabel>
            <Select
              name="Regress"
              disabled={FORM_MODE === "LOCKED" ? true : false}
              value={formData.Regress}
              onChange={(e) => handleInputChange("Regress", e.target.value)}
              label="Regress utförs"
              size="small"
            >
              {boolOptions.map((option) => (
                <MenuItem key={option.Value} value={option.Value}>
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="ClientDirectPayment"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) =>
              handleInputChange("ClientDirectPayment", newVal)
            }
            label="Direktbetalning SEK"
            value={formData.ClientDirectPayment === null ? 0 : formData.ClientDirectPayment}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
            InputProps={
              {
                /*
              endAdornment: (
                <InputAdornment position="end">
                  {formData.CurrencyCode}
                </InputAdornment>
              ),
*/
              }
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="ClientCreditFee"
            label="Kreditavgift SEK"
            value={formData.ClientCreditFee === null ? 0 : formData.ClientCreditFee}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
            onChange={(newVal) => handleInputChange("ClientCreditFee", newVal)}
            InputProps={
              {
                /*
              endAdornment: (
                <InputAdornment position="end">
                  {formData.CurrencyCode}
                </InputAdornment>
              ),
*/
              }
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="ClientServiceFee"
            onChange={(newVal) => handleInputChange("ClientServiceFee", newVal)}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Serviceavgift SEK"
            value={formData.ClientServiceFee === null ? 0 : formData.ClientServiceFee}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>
      </Grid>
    </>
  );
}
